module.exports = __webpack_public_path__ + "3cbe0ada8d2654a9068fe58ddc825c42.svg";